<template>
    <div class="main">
        <div class="title">
            实物教材<span class="orange">（下单包邮）</span>
        </div>
        <div class="help_content">
            <div class="help_item" v-for="(item , index) in typeList" :key="index">

                <router-link :to="'/shop/goodsList/type/' + item.id">
                    <img class="cover alignM fl marginR8" style="width:24px;height:24px;" src="icon/userIcon/poster_icon.png" alt="">
                    <span class="font_position">{{item.name}}</span>
                    <img class="icon_position" style="width:16px;height:16px;" src="icon/userIcon/help_right.png" alt="">
                </router-link>

            </div>
        </div>

    </div>
</template>
<script>
// network api
import categoryApi from '@/api/category';

// platform api and util
import consoleApi from '@/components/platformApi/consoleApi';

export default {
    data(){
        return{
            typeList:[]
        }
    },
    mounted() {
        categoryApi.loadList('SPU', (list) => {
            this.typeList = list;
        });
    }
}
</script>
<style lang="scss" scoped>
.orange {
    color: #FFB946;
}
.main{
    //width:90%;
    margin:0 auto;
    background:#fff;
    margin-top: 16px;
    border-radius: 8px;
    padding: 0 16px;
    box-sizing: border-box;
}

.title{
    padding-top: 12px;
    font-size: 18px;

    font-weight: 600;
    color: #000;

}

.help_content{
    width: 100%;
    padding-bottom: 2px;
    .help_item{
        margin: 16px 0;
        width:100%;
        height: 24px;
        line-height: 24px;
        position: relative;
        .font_position{
            font-size: 14px;

            font-weight: 400;
            color: #333333;

        }
        .icon_position{
            position: absolute;
            top: 4px;
            right: 0px;
        }
    }
}


</style>
